import { cilLockLocked } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CFormInput,
  CFormLabel,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react";
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import '../commonStyle.css'
/**
 * @function PasswordInputField
 * @description for common Password Input field
 * @returns JSX for PasswordInputField
 */

const PasswordInputField = ({
  value,
  changeHandler,
  placeholderText,
  name,
  label,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const showPasswordHandler = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div>
      <CFormLabel className="lable-text">{label}</CFormLabel>
      <CInputGroup >
        <CInputGroupText>
          <CIcon icon={cilLockLocked} />
        </CInputGroupText>
        <CFormInput
          value={value}
          name={name}
          onChange={changeHandler}
          type={showPassword ? "text" : "password"}
          placeholder={placeholderText}
          autoComplete="current-password"
        />
        <CInputGroupText
          className="cursor-pointer"
          onClick={showPasswordHandler}
        >
          {!showPassword ? (
            <FaEye fill="royalblue" />
          ) : (
            <FaEyeSlash fill="#5856d6" />
          )}
        </CInputGroupText>
      </CInputGroup>
    </div>
  );
};

export default PasswordInputField;
